"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.root = void 0;
const React = __importStar(require("react"));
const ReactRedux = __importStar(require("react-redux"));
const Guid = __importStar(require("@genesys/shared/lib/guid"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const MutationsQueueUser = __importStar(require("@genesys/client-core/lib/mutations-queue-user"));
const ScreenAmountProfile = __importStar(require("@genesys/client-core/lib/screen-amount-profile"));
const UserProfile = __importStar(require("@genesys/client-core/lib/user-profile"));
const TranslationsIntegration = __importStar(require("@genesys/client-core/lib/translations-integration"));
const GlobalActions = __importStar(require("@genesys/client-core/lib/global-actions"));
const DebugSettings = __importStar(require("@genesys/client-core/lib/debug-settings"));
const index_1 = require("./containers/core/shell/main/index");
const client_config_1 = require("./client-config");
const moment_1 = __importDefault(require("moment"));
class root extends React.Component {
    constructor(props) {
        super(props);
        this.keyDown = (e) => {
            if (e.keyCode !== 91 && e.keyCode !== 27) {
                return;
            }
            if (e.keyCode === 91) {
                this.lastCallWin = (0, moment_1.default)().unix();
                return;
            }
            // Don't spam request open tab if key is continuously pressed
            const sinceLastWin = (0, moment_1.default)().unix() - this.lastCallWin;
            if (sinceLastWin < 1000) {
                this.props.dispatch(GlobalActions.requestOpenTab({
                    id: Guid.createGuid(),
                    title: "Debug",
                    subject: GlobalActions.createDebugTabSubject()
                }));
            }
        };
        this.state = { clientConfig: client_config_1.config };
    }
    static getDerivedStateFromProps(props, state) {
        const previousAccessToken = (state.clientConfig.authorization.type === "bearer" &&
            state.clientConfig.authorization.accessToken) ||
            "";
        if (props.accessToken !== previousAccessToken) {
            return {
                clientConfig: Object.assign(Object.assign({}, client_config_1.config), { authorization: { type: "bearer", accessToken: props.accessToken } })
            };
        }
        return null;
    }
    componentDidMount() {
        this.lastCallWin = (0, moment_1.default)().unix();
        window.addEventListener("keydown", this.keyDown);
    }
    componentWillUnmount() {
        window.removeEventListener("keydown", this.keyDown);
    }
    render() {
        const { dispatch, mutationQueues, productEntities, userEntities } = this.props;
        return (React.createElement(Contexts.clientConfigContext.Provider, { value: this.state.clientConfig },
            React.createElement(Contexts.dispatchContext.Provider, { value: dispatch },
                React.createElement(DebugSettings.DebugSettingsProvider, null,
                    React.createElement(Contexts.ProductEntitiesContext.Provider, { entities: productEntities, dispatch: dispatch },
                        React.createElement(Contexts.UserEntitiesContext.Provider, { entities: userEntities, dispatch: dispatch },
                            React.createElement(DebugSettings.DebugSettingsConsumer, null, ({ includeServerLog }) => (React.createElement(MutationsQueueUser.MutationsQueueProvider, { dispatch: dispatch, mutationQueues: mutationQueues, includeServerLog: includeServerLog, clientConfigContextValue: this.state.clientConfig },
                                React.createElement(UserProfile.UserProfileProvider, null,
                                    React.createElement(ScreenAmountProfile.ScreenAmountProfileProvider, null,
                                        React.createElement(TranslationsIntegration.TranslationProvider, null,
                                            React.createElement(index_1.MainShellContainer, null)))))))))))));
    }
}
exports.root = root;
function mapStateToProps({ accessToken, queryProduct, queryUser }) {
    return {
        productEntities: queryProduct,
        userEntities: queryUser.entities,
        mutationQueues: queryUser.mutationQueues,
        accessToken
    };
}
exports.Root = ReactRedux.connect(mapStateToProps)(root);
//# sourceMappingURL=root.js.map